import { render, staticRenderFns } from "./addPushView.vue?vue&type=template&id=5b537c82&scoped=true"
import script from "./addPushView.vue?vue&type=script&lang=js"
export * from "./addPushView.vue?vue&type=script&lang=js"
import style0 from "./addPushView.vue?vue&type=style&index=0&id=5b537c82&prod&lang=scss&scoped=true"
import style1 from "./addPushView.vue?vue&type=style&index=1&id=5b537c82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b537c82",
  null
  
)

export default component.exports